import React from 'react';
import './RefundPolicy.css'; // ✅ External CSS
import 'bootstrap/dist/css/bootstrap.min.css';

const RefundPolicy = () => {
  return (
    <div className="refund-container">
      <h1 className="refund-title">Refund Policy</h1>
      <p>
        At <b>Amman Sweets</b>, we take pride in delivering the finest quality sweets and ensuring customer satisfaction.
        If you are not completely satisfied with your purchase, our refund policy is outlined below:
      </p>

      <h3>📌 Customer Note:</h3>
      <p>
        For order-related issues such as <b>payment failures</b> or <b>payment success but order not confirmed</b>, please connect with our support team via 
        WhatsApp: <b>+91 73394 15757</b> with <i>(Payment proof / Screenshot / Mail ID used while ordering)</i>.
      </p>

      <h3>✅ Eligibility for Refund:</h3>
      <p>Refunds are applicable in the following scenarios:</p>
      <ul>
        <li><b>Quality Issue:</b> If the sweets received do not meet our quality standards or are expired.</li>
        <li><b>Wrong Product:</b> If you received a different product than what you ordered.</li>
        <li><b>Damaged Product:</b> If the sweets arrived damaged due to shipping or handling.</li>
      </ul>

      <h3>📅 Notification and Timeframe:</h3>
      <p>
        To request a refund, contact our customer support via WhatsApp: <b>+91 73730 41434</b> or email us at 
        <b> aswinssweetsonline@gmail.com</b> as soon as possible.
      </p>
      <p>
        Provide relevant details such as your order number, a description of the issue, and <b>mandatory photographs & video proof</b>.
      </p>

      <h3>🔎 Assessment and Resolution:</h3>
      <p>
        Upon receiving your request, our team will review the information and may ask for additional evidence. 
        We aim to respond at the earliest and resolve the issue fairly.
      </p>

      <h3>💳 Refund Options:</h3>
      <p>Based on the case, we offer:</p>
      <ul>
        <li><b>Refund:</b> If replacement is not possible or desired, we will refund the amount to the original payment method.</li>
      </ul>

      <h3>⚠️ Important Notes:</h3>
      <ul>
        <li>We request customers to <b>“Read Our Policy Clearly”</b> to avoid future issues.</li>
        <li>We strongly suggest customers <b>record an unboxing video</b> while opening the box after delivery. This helps us process your claim quickly.</li>
      </ul>

      <h3>⏳ Processing Time:</h3>
      <p>
        Refunds will be processed within <b>2-7 working days</b> upon approval. 
        The actual time for the refund to reflect depends on your bank or payment method.
      </p>

      <p>
        Our policy is designed to ensure customer satisfaction. 
        For further assistance, feel free to contact our customer support team.
      </p>
    </div>
  );
};

export default RefundPolicy;
